import React from 'react';
import QuestionLogicForm from '../../../../pages/Question/QuestionLogicForm';
import { useBuilderEditor } from '../../../../features/builder/BuilderEditorContext';

const LogicTab = () => {
  const { formdata, formsectionsdata, fieldeditid, choiceoptions } = useBuilderEditor();

  if (!fieldeditid) {
    return <p className="builder-text-secondary">Save the question first to configure smart rules.</p>;
  }

  const formData = {
    id: formdata?.id,
    fieldId: fieldeditid,
    sectionId: formsectionsdata?.id,
    options: (choiceoptions || []).filter((option) => option.id != null),
    sections: formdata?.sections || [],
    questions: formsectionsdata?.fields || formdata?.fields || [],
  };

  return (
    <QuestionLogicForm
      formData={formData}
      cancelCallback={() => {}}
    />
  );
};

export default LogicTab;
